<template>
  <v-row justify="center">
    <v-dialog
        v-model="show"
        fullscreen
        persistent
        style="height: 100vh"
    >
      <v-card style="background-color: #f5f5f5; border-radius: 0">

        <!-- VENTA -->
        <div v-show="!is_finalizar_venta">
          <ValidationObserver ref="validationObserver">
            <v-form ref="form" lazy-validation  class="pa-1">
              <v-row>
                <v-col :lg="item && item.pedido?11:6" md="12">
                  <!-- Seleccion de Cliente -->
                  <v-row class="pa-2 pb-0 align-center">
                    <v-col cols="1" style="text-align: center">
                      <v-btn
                          icon
                          class="primary"
                          dark
                          @click="show = false"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col lg="11" :md="venta.cliente?9:11">
                      <v-card elevation="2">
                        <v-list v-if="!venta.cliente" one-line>
                          <v-list-item>
                            <v-list-item-content>
                              <v-autocomplete
                                  hide-details
                                  id="formventa_autocomplete_cliente"
                                  v-model="cliente_autocomplete"
                                  :items="cliente_autocomplete_entries"
                                  :search-input.sync="search"
                                  hide-no-data
                                  :label="$t('Cliente')"
                                  dense
                                  outlined
                                  clearable
                                  no-filter
                              >
                                <!--Opciones de seleccion de cliente: crear cliente y usar cliente anónimo-->
                                <template v-slot:append-outer>
                                  <v-row class="ma-0">
                                    <v-col cols="6" class="pa-0 pr-3">
                                      <v-btn fab depressed x-small color="primary" :title="$t('Nuevo cliente')" @click="open_dialog_cliente">
                                        <v-icon small>mdi-account-plus</v-icon>
                                      </v-btn>
                                    </v-col>
                                    <v-col cols="6" class="pa-0">
                                      <v-btn fab depressed x-small color="secondary" :title="$t('Anónimo')" @click="get_anonymous">
                                        <v-icon small>mdi-incognito</v-icon>
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </template>

                                <!--Resultados del autocomplete-->
                                <template v-slot:item="data">
                                  <template>
                                    <v-list-item-avatar>
                                      <img :src="data.item.foto_url_absolute_path" :alt="$t('Foto del cliente')">
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                      <v-list-item-title v-html="data.item.text"/>
                                      <v-list-item-subtitle>
                                        <span v-if="show_email_cliente">{{ data.item.email }}</span>
                                        <span v-if="data.item.email && data.item.movil && show_email_cliente && show_movil_cliente"> - </span>
                                        <span v-if="show_movil_cliente" >{{ data.item.movil }}</span>
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </template>
                                </template>
                              </v-autocomplete>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>

                        <!--Tarjeta con la información del cliente seleccionado-->
                        <MiniCliente v-if="venta.cliente && cliente_venta" :cliente="cliente_venta" />

                      </v-card>
                    </v-col>

                    <v-col cols="2" style="text-align: center"
                           v-if="venta.cliente && !($vuetify.breakpoint.name === 'lg' || $vuetify.breakpoint.name === 'xl') && !(item && item.pedido)">
                      <v-btn
                          class="primary parpadeaSuave"
                          dark
                          @click="dialog_lineas = true"
                      >
                        {{ $t('Añadir línea') }}
                      </v-btn>
                    </v-col>
                  </v-row>

                  <!--Fecha y empleado responsable de la venta-->
                  <v-row class="pl-3 pr-3 mt-0 mb-0 pb-0">
                    <v-col :cols="venta.id ? 4 : 6">
                      <ValidationProvider
                          rules="required"
                          :name="$t('Fecha').toLowerCase()"
                          v-slot="{ errors, classes }"
                      >
                        <div class="control white" :class="classes">
                          <DatePicker
                              v-model="venta.fecha"
                              :title="$t('Fecha')"
                              :allow_future="false"
                              :disabled="!venta.id && !($store.state.auth.user.tipo_empleado === 'admin' ||
                              $store.getters['auth/has_permission']('modificar_precios_en_venta'))"
                          />
                        </div>
                        <span class="error--text">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </v-col>

                    <v-col :cols="venta.id ? 4 : 6">
                      <ValidationProvider
                          rules="required"
                          v-slot="{ errors, classes }"
                      >
                        <div class="control" :class="classes">
                          <v-select
                              class="white"
                              hide-details
                              :label="$t('Empleado')"
                              v-model="venta.assigned_to"
                              :items="data_form.empleados"
                              :no-data-text="$t('No hay datos')"
                              dense
                              outlined
                              @change="set_user_venta"
                          />
                        </div>
                      </ValidationProvider>
                    </v-col>

                    <v-col cols="4" v-if="venta.id && ($store.state.auth.user.is_superuser ||
                $store.state.centro.centro.country !== CONSTANTS.COUNTRY.SPAIN)">
                      <ValidationProvider
                          rules="required"
                          :name="$t('Ticket').toLowerCase()"
                          v-slot="{ errors, classes }"
                      >
                        <div class="control" :class="classes">
                          <v-text-field
                              v-model="venta.num_ticket"
                              type="number"
                              hide-details
                              :label="$t('Ticket')"
                              outlined
                              dense
                              class="white"
                          />
                        </div>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <!--Acciones relacionadas con el cliente: ver deudas, usar puntos y usar tarjetas regalo/fidelidad-->
                  <v-row
                      v-if="venta.cliente && cliente_venta &&!cliente_venta.is_anonymous" class="pt-0 ma-0">
                    <v-col cols="12" class="text-left pa-0">
                      <v-btn
                          @click="open_dialog_deudas_cliente"
                          v-if="cliente_venta.importe_deudas > 0"
                          class="ma-2 mt-0 white--text parpadeaSuave"
                          small
                          depressed
                          color="red"
                      >{{ $t("Ver deudas") }}</v-btn>

                      <v-btn
                          class="ma-2 mt-0 white--text"
                          small
                          color="green"
                          @click="dialog_historial = true"
                      >{{ $t("Historial") }}</v-btn>

                      <v-btn
                          v-if="cliente_venta.puntos && venta.total > 0 && !venta.puntos_utilizados && !(item && item.puntos_utilizados) && !(item && item.pedido)"
                          class="ma-2 mt-0 white--text"
                          small
                          color="orange"
                          @click="open_dialog_usar_puntos"
                      >{{ $t("Puntos") }}</v-btn>

                      <v-btn
                          v-if="venta.puntos_utilizados || (item && item.puntos_utilizados)"
                          class="ma-2 mt-0 mr-0 white--text"
                          small
                          disabled
                          color="grey"
                      >{{ $t("Puntos utilizados") }}</v-btn>

                      <v-btn icon class="red mr-1 mb-2" dark x-small @click="desasignar_puntos"
                             v-if="venta.puntos_utilizados && !venta.id" style="margin-left: 3px">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>

<!--                      Boton generico para canjear tarjeta, muestra las 2 tabs-->
<!--                      <v-btn-->
<!--                          v-if="!venta.tarjeta_fidelidad_vendida && !venta.importe_tarjeta_regalo"-->
<!--                          class="ma-2 mt-0 white&#45;&#45;text"-->
<!--                          small-->
<!--                          color="green"-->
<!--                          @click="open_dialog_canjear_tarjeta(0)"-->
<!--                          :disabled="venta.total != null && Number(venta.total) === 0"-->
<!--                      >{{ $t("Canjear tarjeta") }}</v-btn>-->

                      <span v-if="venta.tarjeta_fidelidad_vendida || venta.importe_tarjeta_regalo > 0">
                        <v-btn
                            class="ma-2 mt-0 white--text mr-0"
                            small
                            disabled
                            color="grey"
                        >
                          {{ $t("Tarjeta canjeada") }}
                        </v-btn>
                        <v-btn icon class="red mt-0 mb-2" dark x-small @click="desasignar_tarjeta" v-if="!venta.id"
                               style="margin-left: 3px">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </span>

                      <!--Número de bonos gastados-->
<!--                      <span class="ml-6"-->
<!--                            v-if="bonos_gastados.previos.count>0 || bonos_gastados.nuevos.count>0"-->
<!--                      >-->
<!--                        {{$t('Bonos consumido')+':'}}-->
<!--                      </span>-->
<!--                      <span class="ml-2" v-if="bonos_gastados.previos.count>0">-->
<!--                        <v-btn-->
<!--                            fab depressed x-small color="red"-->
<!--                            style="cursor: default"-->
<!--                            :title="$t('Bonos previos gastados')"-->
<!--                            class="mt-0 mb-2"-->
<!--                        >-->
<!--                          <span class="white&#45;&#45;text big">{{bonos_gastados.previos.count}}</span>-->
<!--                        </v-btn>-->
<!--                      </span>-->

<!--                      <span class="ml-2" v-if="bonos_gastados.nuevos.count>0">-->
<!--                        <v-btn-->
<!--                            fab depressed x-small color="blue"-->
<!--                            style="cursor: default"-->
<!--                            :title="$t('Bonos nuevos gastados')"-->
<!--                            class="mt-0 mb-2"-->
<!--                        >-->
<!--                          <span class="white&#45;&#45;text big">{{bonos_gastados.nuevos.count}}</span>-->
<!--                        </v-btn>-->
<!--                      </span>-->

                      <span v-if="bonos_gastados.previos.count>0 || bonos_gastados.nuevos.count>0">
                        <v-btn
                            class="ma-2 mt-0 white--text "
                            small
                            color="grey"
                            @click="dialog_bono_gastado = true"
                        >{{ $t("Ver bonos consumidos") }}</v-btn>
                      </span>

                      <span v-if="descuentos_por_periodos.length > 0">
                        <v-btn
                            class="ma-2 mt-0 white--text "
                            small
                            color="grey"
                            @click="dialog_descuento_periodo = true"
                        >{{ $t("Ver descuentos por periodo") }}</v-btn>
                      </span>
                    </v-col>
                  </v-row>

                  <v-row
                      v-if="venta.cliente && cliente_venta && cliente_venta.is_anonymous" class="pt-0 ma-0">
                    <v-col cols="12" class="text-left pa-0">
<!--                      <v-btn-->
<!--                          v-if="!venta.importe_tarjeta_regalo"-->
<!--                          class="ma-2 mt-0 white&#45;&#45;text"-->
<!--                          small-->
<!--                          color="green"-->
<!--                          @click="open_dialog_canjear_tarjeta(0)"-->
<!--                          :disabled="venta.total != null && Number(venta.total) === 0"-->
<!--                      >{{ $t("Canjear tarjeta") }}</v-btn>-->

                      <div v-if="venta.tarjeta_fidelidad_vendida || venta.importe_tarjeta_regalo > 0">
                        <v-btn
                            class="ma-2 mt-0 white--text mr-0"
                            small
                            disabled
                            color="grey"
                        >
                          {{ $t("Tarjeta canjeada") }}
                        </v-btn>
                        <v-btn icon class="red ma-0 mb-2" dark x-small @click="desasignar_tarjeta" v-if="!venta.id">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </div>

                    </v-col>
                  </v-row>

                  <v-divider class="ml-8 mr-8 mb-2"/>

                  <!--Lineas de la venta-->
                  <div class="contLineasVenta">
                    <div
                        v-for="(current_linea, index) in venta.lineas_venta_rectificativas"
                        :key="'rectificar' + String(index)"
                        class="overflow-y-auto"
                    >
                      <LineaRectificativaFormVenta
                          :current_linea="current_linea"
                          :venta="venta"
                      />
                    </div>

                    <div
                        v-for="(current_linea, index) in venta.lineas_venta"
                        :key="index"
                        class="overflow-y-auto"
                    >
                      <LineaFormVenta
                        :current_linea="current_linea"
                        :index="index"
                        :impuestos="data_form.impuestos"
                        :empleados="data_form.empleados"
                        :tipos_descuentos="data_form.tipos_descuentos"
                        :can_aplicar_descuento="can_aplicar_descuento"
                        :can_modificar_precio="can_modificar_precio"
                        :aws_s3_bucket_url="aws_s3_bucket_url"
                        @toggle_collapse="toggle_collapse"
                        @usar_sesion="usar_sesion"
                        @delete_linea_venta="delete_linea_venta"
                        @recheck_bono="check_bono"
                        @on_change_uds_bono="modificar_uds_bono"
                        @on_change_uds_pack="modificar_uds_pack"
                        :venta="venta"
                        :is_pedido="item && item.pedido"
                      />
                    </div>
                    <div ref="scrollBottom"></div>
                  </div>

                  <!--Footer de la venta (descuento directo a la venta y observaciones)-->
                  <v-card elevation="6" class="ma-2 footerVenta primary">
                    <v-card-text>
                      <v-row class="mt-2">
                        <v-col cols="4">
                          <v-text-field
                              v-model="venta.valor_descuento"
                              class="white"
                              type="number"
                              hide-details
                              outlined
                              dense
                              :readonly="(item && item.pedido) || !can_aplicar_descuento"
                              :disabled="venta.is_rectificada"
                          >
                            <template v-slot:label>
                              <span class='labelFooterVenta'>{{ $t('Descuento') }}</span>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-select
                              class="white"
                              v-model="venta.tipo_descuento"
                              hide-details
                              :items="data_form.tipos_descuentos"
                              :no-data-text="$t('No hay datos')"
                              dense
                              outlined
                              :readonly="(item && item.pedido) || !can_aplicar_descuento"
                              :disabled="venta.is_rectificada"
                          >
                            <template v-slot:label>
                              <span class='labelFooterVenta'>{{ $t('Tipo descuento') }}</span>
                            </template>
                          </v-select>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field
                              class="white"
                              v-model="venta.base_imponible"
                              type="number"
                              hide-details
                              outlined
                              dense
                              readonly
                          >
                            <template v-slot:label>
                              <span class='labelFooterVenta'>{{ $t('Base imponible') }}</span>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col cols="12">
                          <v-text-field
                              class="white"
                              v-model="venta.observaciones"
                              hide-details
                              outlined
                              dense
                          >
                            <template v-slot:label>
                              <span class='labelFooterVenta'>{{ $t('Observaciones') }}</span>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <!--Botones pago-->
                      <v-row class="mt-0">
                        <v-col cols="5" style="text-align: center">
                          <span class="font-weight-bold v-btn black--text pa-1 d-flex" style="background-color: #ffffff">
                            {{ $t("Total") }}: {{ venta.total | money }}
                          </span>
                        </v-col>

                        <v-col
                            cols="6"
                            v-if="(venta.total != null && Number(venta.total) === 0 && venta.importe_tarjeta_regalo) &&
                            (!venta.id || ($store.state.auth.user.is_superuser || $store.state.centro.centro.country !== CONSTANTS.COUNTRY.SPAIN))"
                        >
                          <!-- T. REGALO -->
                          <v-btn
                              :disabled="!is_available_btn_pago || venta.id"
                              text
                              dark
                              @click="set_forma_pago(CONSTANTS.FORMAS_PAGO.TARJETA_REGALO)"
                          >
                            <v-icon>mdi-cash</v-icon>
                            {{ $t("Pagar usando") + ' ' + $t("Tarjeta Regalo") }}
                          </v-btn>
                        </v-col>

                        <v-col
                            cols="6"
                            v-if="(venta.total != null && Number(venta.total) === 0 && venta.tarjeta_fidelidad_vendida) &&
                            (!venta.id || ($store.state.auth.user.is_superuser || $store.state.centro.centro.country !== CONSTANTS.COUNTRY.SPAIN))"
                        >
                          <!-- T. REGALO -->
                          <v-btn
                              :disabled="!is_available_btn_pago || venta.id"
                              text
                              dark
                              @click="set_forma_pago(CONSTANTS.FORMAS_PAGO.TARJETA_FIDELIDAD)"
                          >
                            <v-icon>mdi-cash</v-icon>
                            {{ $t("Pagar usando") + ' ' + $t("Tarjeta Fidelidad") }}
                          </v-btn>
                        </v-col>

                        <v-col
                            cols="2"
                            v-if="!(venta.total != null && Number(venta.total) === 0 && (venta.importe_tarjeta_regalo || venta.tarjeta_fidelidad_vendida)) &&
                            (!venta.id || ($store.state.auth.user.is_superuser || $store.state.centro.centro.country !== CONSTANTS.COUNTRY.SPAIN)) &&
                             !(item && item.pedido_forma_pago && item.pedido_forma_pago <= 2)"
                        >
                          <!-- EFECTIVO -->
                          <v-btn
                              v-if="data_form.formas_pago"
                              :disabled="!is_available_btn_pago"
                              text
                              dark
                              @click="set_forma_pago(data_form.formas_pago[0].value)"
                          >
                            <v-icon>mdi-cash</v-icon>
                            {{ data_form.formas_pago[0].text }}
                          </v-btn>
                        </v-col>

                        <v-col
                            cols="2"
                            v-if="!(venta.total != null && Number(venta.total) === 0 && (venta.importe_tarjeta_regalo || venta.tarjeta_fidelidad_vendida)) &&
                            (!venta.id || ($store.state.auth.user.is_superuser || $store.state.centro.centro.country !== CONSTANTS.COUNTRY.SPAIN)) &&
                             !(item && item.pedido_forma_pago && item.pedido_forma_pago <= 2)"
                        >
                          <!-- TARJETA -->
                          <v-btn
                              v-if="data_form.formas_pago"
                              :disabled="!is_available_btn_pago"
                              text
                              dark
                              @click="set_forma_pago(data_form.formas_pago[1].value)"
                          >
                            <v-icon>mdi-credit-card</v-icon>
                            {{ data_form.formas_pago[1].text }}
                          </v-btn>
                        </v-col>

                        <v-col
                            cols="2"
                            v-if="!(venta.total != null && Number(venta.total) === 0 && (venta.importe_tarjeta_regalo || venta.tarjeta_fidelidad_vendida)) &&
                            (!venta.id || ($store.state.auth.user.is_superuser || $store.state.centro.centro.country !== CONSTANTS.COUNTRY.SPAIN)) &&
                             (item && item.pedido_forma_pago && item.pedido_forma_pago === 1)"
                        >
                          <!-- Online -->
                          <v-btn
                              v-if="data_form.formas_pago"
                              :disabled="!is_available_btn_pago"
                              text
                              dark
                              @click="set_forma_pago(data_form.formas_pago[7].value)"
                          >
                            <v-icon>mdi-credit-card</v-icon>
                            {{ data_form.formas_pago[7].text }}
                          </v-btn>
                        </v-col>

                        <v-col
                            cols="2"
                            v-if="!(venta.total != null && Number(venta.total) === 0 && (venta.importe_tarjeta_regalo || venta.tarjeta_fidelidad_vendida)) &&
                            (!venta.id || ($store.state.auth.user.is_superuser || $store.state.centro.centro.country !== CONSTANTS.COUNTRY.SPAIN)) &&
                             (item && item.pedido_forma_pago && item.pedido_forma_pago === 2)"
                        >
                          <!-- PAYPAL -->
                          <v-btn
                              v-if="data_form.formas_pago"
                              :disabled="!is_available_btn_pago"
                              text
                              dark
                              @click="set_forma_pago(data_form.formas_pago[6].value)"
                          >
                            <v-icon>mdi-credit-card</v-icon>
                            {{ data_form.formas_pago[6].text }}
                          </v-btn>
                        </v-col>

                        <v-col
                            cols="2"
                            v-if="!(venta.total != null && Number(venta.total) === 0 && (venta.importe_tarjeta_regalo || venta.tarjeta_fidelidad_vendida)) &&
                            (!venta.id || ($store.state.auth.user.is_superuser || $store.state.centro.centro.country !== CONSTANTS.COUNTRY.SPAIN)) &&
                            (!item || item && !item.pedido_forma_pago || !(item && item.pedido_forma_pago && item.pedido_forma_pago <= 2))"
                        >
                          <!--Otros-->
                          <v-menu offset-y bottom right>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                  :disabled="!is_available_btn_pago"
                                  v-bind="attrs" text v-on="on" dark>
                                {{ $t("Otros") }}
                                <v-icon>mdi-chevron-down</v-icon>
                              </v-btn>
                            </template>
                            <v-list dense class="white">
                              <div v-for="(current_forma_pago, index) in data_form.formas_pago" :key="index">
                                <v-list-item v-if="index>1" :data-value="current_forma_pago.value" @click="set_forma_pago(current_forma_pago.value)">
                                  <v-list-item-action>
                                    <v-list-item-title>{{ current_forma_pago.text }}</v-list-item-title>
                                  </v-list-item-action>
                                </v-list-item>
                              </div>
                            </v-list>
                          </v-menu>
                        </v-col>

                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>

                <!-- Tablas de items a añadir -->
                <v-col v-if="$vuetify.breakpoint.name === 'lg' || $vuetify.breakpoint.name === 'xl'" lg="6" class="pr-6 pl-2 mt-2" v-show="venta.cliente && !(item && item.pedido)">
                  <TabItemFormVenta
                      ref="tabla_items"
                      :lista_dict="lista_dict"
                      :hide_anonymous="cliente_venta && !cliente_venta.is_anonymous"
                      @add_linea_venta="add_linea_venta"
                      @click_nuevo_servicio="click_nuevo_servicio"
                      @click_nuevo_producto="click_nuevo_producto"
                      @click_nuevo_bono="click_nuevo_bono"
                      @click_nuevo_pack="click_nuevo_pack"
                      @click_nueva_tarjeta_regalo="click_nueva_tarjeta_regalo"
                      @click_nueva_tarjeta_fidelidad="click_nueva_tarjeta_fidelidad"
                      @click_nueva_suscripcion="click_nueva_suscripcion"
                  />
                </v-col>

                <!-- Tablas de items a añadir -->
                <v-col v-else cols="1" class="pr-6 pl-2 mt-2" v-show="venta.cliente">

                </v-col>
              </v-row>
            </v-form>
          </ValidationObserver>
        </div>

        <!-- FIN VENTA -->

        <FinalizarVenta
            v-if="is_finalizar_venta"
            :validationObserver="this.$refs.validationObserver"
            :venta_original="venta"
            :total="venta.total"
            :cliente_venta="cliente_venta"
            :centro="centro"
            :data_form="data_form"
            :consumidos_previos="bonos_gastados.previos.count"
            :consumidos_nuevos="bonos_gastados.nuevos.count"
            @not_is_finalizar_venta="()=>{this.is_finalizar_venta=false}"
            @on_save="(venta_guardada)=>{this.$emit('on_save', venta_guardada)}"
        />

      </v-card>
    </v-dialog>

    <!-- Dialogo de cliente con el formulario -->
    <FormCliente v-if="dialog_cliente"
                 v-model="dialog_cliente"
                 :item="{}"
                 @on_save="set_cliente"/>

    <DialogDeudasCliente
        v-if="venta.cliente && dialog_deudas_cliente > 0"
        v-model="dialog_deudas_cliente"
        :cliente="cliente_venta"
    />

    <DialogUsarPuntos
        v-if="dialog_usar_puntos"
        v-model="dialog_usar_puntos"
        :venta="venta"
        :cliente="cliente_venta"
        @on_usar_puntos="usar_puntos"
    />

    <DialogCanjearTarjeta
        v-if="dialog_canjear_tarjeta"
        v-model="dialog_canjear_tarjeta"
        :cliente="cliente_venta"
        :total="venta.total"
        :show_specific_tab="show_specific_tab"
        @on_select_tarjeta_regalo="set_tarjeta_regalo"
        @on_select_tarjeta_fidelidad="set_tarjeta_fidelidad"
    />

    <!-- Para mostrar la tabla para añadir lineas de venta en tablets-->
    <Dialog :title="$t('Añadir línea')" v-if="!($vuetify.breakpoint.name === 'lg' || $vuetify.breakpoint.name === 'xl')"
            v-show="dialog_lineas" v-model="dialog_lineas" width="1000" max_width="1000">
      <template v-slot:content>
        <TabItemFormVenta
            ref="tabla_items"
            :lista_dict="lista_dict"
            :hide_anonymous="cliente_venta && !cliente_venta.is_anonymous"
            @add_linea_venta="add_linea_venta"
            @click_nuevo_servicio="click_nuevo_servicio"
            @click_nuevo_producto="click_nuevo_producto"
            @click_nuevo_bono="click_nuevo_bono"
            @click_nuevo_pack="click_nuevo_pack"
            @click_nueva_tarjeta_regalo="click_nueva_tarjeta_regalo"
            @click_nueva_tarjeta_fidelidad="click_nueva_tarjeta_fidelidad"
            @click_nueva_suscripcion="click_nueva_suscripcion"
        />
      </template>
    </Dialog>


    <FormServicio
        v-if="dialog_servicio"
        v-model="dialog_servicio"
        @on_save="on_save_servicio"
    />

    <FormProducto
        v-if="dialog_producto"
        v-model="dialog_producto"
        @on_save="on_save_producto"
    />

    <FormBono
        v-if="dialog_bono"
        v-model="dialog_bono"
        @on_save="on_save_bono"
    />

    <FormPack
        v-if="dialog_pack"
        v-model="dialog_pack"
        @on_save="on_save_pack"
    />

    <FormTarjetaRegalo
        v-if="dialog_tarjeta_regalo"
        v-model="dialog_tarjeta_regalo"
        @on_save="on_save_tarjeta_regalo"
    />

    <FormTarjetaFidelidad
        v-if="dialog_tarjeta_fidelidad"
        v-model="dialog_tarjeta_fidelidad"
        @on_save="on_save_tarjeta_fidelidad"
    />

    <FormSuscripcion
        v-if="dialog_suscripcion"
        v-model="dialog_suscripcion"
        @on_save="on_save_suscripcion"
    />

    <DialogBonosGastados
        v-if="dialog_bono_gastado"
        v-model="dialog_bono_gastado"
        :lista_gastados="bonos_gastados"
        :bonos_asignables="bonos_asignables"
        :bonos_previos="bonos_previos"
    />

    <DialogDescuentosPeriodo
        v-if="dialog_descuento_periodo"
        v-model="dialog_descuento_periodo"
        :lista_descuentos="descuentos_por_periodos"
    />

    <DialogHistorial
        v-if="dialog_historial"
        v-model="dialog_historial"
        :cliente="cliente_venta"
        :id_cliente="cliente_venta.id"
    />
  </v-row>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Vue from "vue";
import CONSTANTS from "@/utils/constants";
import empleados from "../../Configuracion/Empleados/Empleados";
import venta from "@/store/modules/venta/venta";
export default {
  // Nota: A aquel que tenga que debugear/refactorizar los bonos, mis condolencias y buena suerte.

  // Cosas a tener en cuenta de bonos:
  // - Hay bonos antiguos (ya comprados pero no consumidos) y nuevos (se venden en la propia venta)
  // - Hay dos maneras de incrementar la cantidad tanto de los bonos nuevos como de los
  // servicios/productos que usan bonos, el campo unidades o añadir más líneas
  // - Las restricciones para determinar si se puede asignar un servicio/producto es que no se supere las sesiones de
  // ese servicio/producto en el bono y que la suma de todas las sesiones usadas no supere el limite de sesiones del bono
  // - El bono se consume si se llega a su limite de sesiones
  // - El limite de sesiones puede ser bono.limite_sesiones (acepta null) o bono.producto[x] / bono.servicio[x]

  data: () => ({
    CONSTANTS,
    // active_tab: "tab-servicio",
    is_finalizar_venta: false,
    query_term_cliente_autocomplete: '',
    // Variable para almacenar todos los datos del cliente
    cliente_venta: null,
    // Variable para sacar el escandallo
    servicios_venta: [],
    venta: {},
    data_form: {},
    dialog_deudas_cliente: false,
    dialog_cliente: false,
    dialog_usar_puntos: false,
    dialog_canjear_tarjeta: false,
    dialog_lineas: false,
    aws_s3_bucket_url: process.env.VUE_APP_AWS_S3_BUCKET,
    importe_tarjeta_regalo_maximo: 0,
    // Dialogs conceptos
    dialog_servicio: false,
    dialog_producto: false,
    dialog_bono: false,
    dialog_pack: false,
    dialog_tarjeta_regalo: false,
    dialog_tarjeta_fidelidad: false,
    dialog_suscripcion: false,
    dialog_bono_gastado: false,
    dialog_descuento_periodo: false,
    //autocomplete
    cliente_autocomplete: null,
    cliente_autocomplete_entries: [],
    cliente_autocomplete_q: '',
    //tabs de lineas de venta
    lista_dict: [],
    //bonos asignables a servicios/productos
    bonos_asignables:{},
    bonos_previos: {},
    bonos_gastados: {
      previos: {
        count: 0
      },
      nuevos: {
        count: 0
      }
    },
    set_tarjetas_regalo: new Set(),
    descuentos_por_periodos: [],
    //contador id pack
    contador_pack: 0,
    // para mostrar solo una tab en canjear tarjetas
    show_specific_tab:0,

    // Debounce autocomplete cliente
    autocomplete_cliente_contador: null,
    autocomplete_cliente_timeout: 500,

    dialog_historial: false,
    tarifa: null,

  //   comprobacion de tbai, productos y servicios se excluyen mutuamente
  //   has_added_item: null
  }),
  props: ['value', 'item', 'cliente'],
  computed: {
    // disable_cobrar_tbai(){
    //   return this.$store.state.centro.centro.is_ticketbai_activo &&
    //       this.venta.lineas_venta.filter(linea => !!linea.producto). length > 0 &&
    //       this.venta.lineas_venta.filter(linea => !!linea.servicio). length > 0
    // },
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    centro(){
      return this.$store.state.centro.centro
    },
    user: {
      get () {
        return this.$store.getters['auth/user']
      }
    },
    search: {
      get() {
        return this.cliente_autocomplete_q
      },
      set(searchInput) {
        if (!searchInput) return;
        if (this.cliente_autocomplete_q !== searchInput) {
          this.cliente_autocomplete_q = searchInput
          // this.get_clientes_autocomplete()
        }
      },
    },

    devolver(){
      const devolver = parseFloat((this.venta.entrega - this.venta.total).toFixed(2))
      return devolver > 0 ? devolver : 0
    },
    deuda(){
      const deuda = parseFloat((this.venta.total - this.venta.entrega).toFixed(2))
      return (this.venta.entrega >= 0 && deuda > 0) ? deuda : 0
    },
    is_available_btn_pago(){
      return this.venta.cliente && this.venta.lineas_venta.length > 0 &&
          !(!!this.venta.centro && this.venta.centro !== this.$store.state.centro.centro.id)
    },
    can_modificar_precio(){
      if (this.$store.state.auth.user.tipo_empleado === 'admin') {
        return true
      } else {
        if (this.$store.getters['auth/has_permission']("modificar_precios_en_venta")) {
          return true
        }
      }
      return false
    },
    can_aplicar_descuento(){
      if (this.$store.state.auth.user.tipo_empleado === 'admin') {
        return true
      } else {
        if (this.$store.getters['auth/has_permission']("aplicar_descuentos_en_venta")) {
          return true
        }
      }
      return false
    },
    show_email_cliente(){
      if (this.$store.state.auth.user.tipo_empleado === 'admin') {
        return true
      } else {
        if (this.$store.getters['auth/has_permission']("ver_email_cliente")) {
          return true
        }
      }
      return false
    },
    show_movil_cliente(){
      if (this.$store.state.auth.user.tipo_empleado === 'admin') {
        return true
      } else {
        if (this.$store.getters['auth/has_permission']("ver_movil_cliente")) {
          return true
        }
      }
      return false
    },
  },

  methods: {

    initialize_venta(){
      this.venta = {}
      this.venta.assigned_to = this.user.id
      this.venta.fecha = this.$moment().format('YYYY-MM-DD')
      this.venta.valor_descuento = 0
      this.venta.tipo_descuento = 'p'
      this.venta.total = 0
      this.venta.base_imponible = 0
      this.venta.lineas_venta = []
      this.venta.lineas_venta_rectificativas = []
      this.venta.entrega = 0
      this.venta.entrega_efectivo = 0
      this.venta.entrega_tarjeta = 0
      this.venta.is_enviar_encuesta = this.centro.is_enviar_encuesta
      this.venta.tips = []

      this.venta = {...this.venta}
    },

    /**
     * Añade una nueva línea de venta
     * @param item,
     * @param tab
     */
    async add_linea_venta(item, tab){

      let tipo_item = tab.replace('tab-', '')
      if(this.cliente_venta && this.cliente_venta.is_anonymous && (tipo_item === 'bono' || tipo_item === 'tarjeta_fidelidad')){
        return
      }

      if(this.venta.is_rectificada) {
        return this.$snotify.warning(
              this.$t('No se puede modificar una venta rectificada')
            )
      }

      // if (this.$store.state.centro.centro.is_ticketbai_activo) {
      //   if (!this.has_added_item && (tipo_item === 'servicio' || tipo_item === 'producto')){
      //     this.has_added_item = tipo_item
      //   }
      //
      //   if ((tipo_item === 'servicio' || tipo_item === 'producto') && this.has_added_item !== tipo_item) {
      //     return this.$snotify.error(
      //       this.$t('No puedes añadir productos y servicios simultáneamente en ventas con Ticketbai activado.'),
      //       this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
      //     )
      //   }
      // }

      if (tipo_item === 'tarjeta_regalo' && this.set_tarjetas_regalo.has(item.id)){
        return this.$snotify.error(
            this.$t('Una tarjeta de regalo solo se puede vender una vez.'),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }

      //Para los servicios y productos si es un pack
      let servicios = null
      let productos = null

      // Vemos cuál es el impuesto
      let impuesto = this.centro.impuesto;
      if(tipo_item === 'producto'){
        impuesto = this.centro.impuesto_productos;
      }else if(tipo_item === 'servicio'){
        impuesto = this.centro.impuesto_servicios
      }else if(tipo_item === 'pack'){

        // si es ticketbai no se puede mezclar servicios y productos
        // if (this.$store.state.centro.centro.is_ticketbai_activo) {
        //   if (item.servicios.length > 0 && item.productos.length > 0) {
        //     return this.$snotify.error(
        //         this.$t('No puedes añadir packs con productos y servicios simultáneamente en ventas con Ticketbai activado.'),
        //         this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        //     )
        //   }
        //   if (item.servicios.length > 0) {
        //     if (!this.has_added_item) {
        //       this.has_added_item = 'servicio'
        //     } else if (this.has_added_item !== 'servicio') {
        //       return this.$snotify.error(
        //           this.$t('No puedes añadir productos y servicios simultáneamente en ventas con Ticketbai activado.'),
        //           this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        //       )
        //     }
        //   } else if (item.productos.length > 0) {
        //     if (!this.has_added_item) {
        //       this.has_added_item = 'producto'
        //     } else if (this.has_added_item !== 'producto') {
        //       return this.$snotify.error(
        //           this.$t('No puedes añadir productos y servicios simultáneamente en ventas con Ticketbai activado.'),
        //           this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        //       )
        //     }
        //   }
        // }

        let params = {
          params: {
            id__in: item.servicios.join(',')
          }
        }
        if(item.servicios.length > 0){
          const resp = await this.$store.dispatch('servicio/get_servicios', params)
          servicios = resp['results']
        }

        params = {
          params: {
            id__in: item.productos.join(',')
          }
        }
        if(item.productos.length > 0){
          const resp = await this.$store.dispatch('producto/get_productos', params)
          productos = resp['results']
        }
      }

      // Vemos si tiene descuento por periodos
      let valor_descuento = 0
      if(tipo_item === 'servicio'){
        this.descuentos_por_periodos.every((currentDescuento) =>{
          if(currentDescuento.servicios.includes(item.id)){
            if(currentDescuento.fecha_inicio <= this.venta.fecha && currentDescuento.fecha_fin >= this.venta.fecha){
              valor_descuento = currentDescuento.descuento
            }
            return true
          }
        });
      }

      if(item.impuesto){
        impuesto = item.impuesto
      }

      let assigned_to = this.data_form.empleados.find(empleado => empleado.value === this.venta.assigned_to)
      if (assigned_to.disabled) {
        assigned_to = this.$store.state.auth.user.id
      } else {
        assigned_to = assigned_to.value
      }

      let linea_venta = {
        collapsed: true,
        descripcion: item.nombre,
        assigned_to: assigned_to,
        cantidad: 1,
        valor_descuento: valor_descuento,
        tipo_descuento: 'p',
        impuesto,
        precio: item.precio,
        total: 0
      }

      // tarifas
      if(tipo_item === 'servicio' && item.is_tarifas){
        switch (this.tarifa) {
          case 0:
            linea_venta.precio = item.precio
            break
          case 1:
            linea_venta.precio = item.precio_tarifa1
            break
          case 2:
            linea_venta.precio = item.precio_tarifa2
            break
          case 3:
            linea_venta.precio = item.precio_tarifa3
            break
          case 4:
            linea_venta.precio = item.precio_tarifa4
            break
        }
      }

      //va añadiendo los bonos a bonos_asignables
      if(tipo_item === 'bono'){

        if(!(item.id in this.bonos_asignables)){
          this.bonos_asignables[item.id] = {
            'cantidad':1,
            'disponibles': {
              'servicios': {},
              'productos': {},
              'total': 0
            },
            'usados':{
              'servicios': {},
              'productos': {},
              'total': 0
            },
            'modelo':{
              'servicios': {},
              'productos': {},
              'total': 0
            },
          }
          const data = await this.$store.dispatch('bono/get_bonos', {
            params: {
              id: item.id
            }
          })
          const bono = data['results'][0]

          //para crear el bono_vendido_id
          linea_venta= {
            ...linea_venta,
            'categoria': bono.categoria,
            'limite_sesiones': bono.limite_sesiones,
            'dias_caducidad': bono.dias_caducidad,
            'productos': bono.productos,
            'servicios': bono.servicios,
          }

          this.bonos_asignables[bono.id].nombre = bono.nombre
          this.bonos_asignables[bono.id].modelo.total = linea_venta.limite_sesiones
          this.bonos_asignables[bono.id].disponibles.total = linea_venta.limite_sesiones

          //se recorren los servivios y productos de los bonos, e van añadiendo a modelo/disponibles/usados
          bono.servicios.forEach((current_servicio)=>{
            this.bonos_asignables[bono.id].modelo.servicios[current_servicio.servicio] = current_servicio.cantidad
            this.bonos_asignables[bono.id].disponibles.servicios[current_servicio.servicio] = current_servicio.cantidad
            this.bonos_asignables[bono.id].usados.servicios[current_servicio.servicio] = 0
          })
          bono.productos.forEach((current_producto)=>{
            this.bonos_asignables[bono.id].modelo.productos[current_producto.producto] = current_producto.cantidad
            this.bonos_asignables[bono.id].disponibles.productos[current_producto.producto] = current_producto.cantidad
            this.bonos_asignables[bono.id].usados.productos[current_producto.producto] = 0
          })

        } else {
          this.bonos_asignables[item.id].cantidad += 1

          if (item.limite_sesiones !== null) {
            this.bonos_asignables[item.id].disponibles.total += Number(item.limite_sesiones)
          }

          Object.keys(this.bonos_asignables[item.id].modelo.servicios).forEach((key)=>{
            this.bonos_asignables[item.id].disponibles.servicios[key]+=this.bonos_asignables[item.id].modelo.servicios[key]
          })
          Object.keys(this.bonos_asignables[item.id].modelo.productos).forEach((key)=>{
            this.bonos_asignables[item.id].disponibles.productos[key]+=this.bonos_asignables[item.id].modelo.productos[key]
          })
        }
      }

      linea_venta[tipo_item] = item.id
      this.venta.lineas_venta.push(linea_venta)

      if(tipo_item === 'tarjeta_regalo'){
        this.set_tarjetas_regalo.add(item.id)
      }

      if(tipo_item === 'servicio' || tipo_item === 'producto'){
        await this.check_bono(linea_venta)
      } else if(tipo_item === 'bono'){
        //al añadir un bono comprobamos si hay alguna linea que lo pueda usar
        this.venta.lineas_venta.forEach((linea)=>{
          if(linea.servicio || linea.producto){
            this.check_bono(linea)
          }
        })
      }


      // Si es un pack añadimos los productos y servicios
      if(tipo_item === 'pack'){
        this.contador_pack += 1
        linea_venta.id_pack=this.contador_pack
        if(servicios){
          servicios.forEach((current_servicio) => {
            const linea_venta = {
              servicio: current_servicio.id,
              collapsed: true,
              descripcion: current_servicio.nombre,
              assigned_to: this.venta.assigned_to,
              cantidad: 1,
              valor_descuento: 0,
              tipo_descuento: 'p',
              impuesto: current_servicio.impuesto ?  current_servicio.impuesto : this.centro.impuesto_servicios,
              precio: 0,
              total: 0,
              id_pack: this.contador_pack
            }
            this.venta.lineas_venta.push(linea_venta)
          })
        }
        if(productos){
          productos.forEach((current_producto) => {
            const linea_venta = {
              producto: current_producto.id,
              collapsed: true,
              descripcion: current_producto.nombre,
              assigned_to: this.venta.assigned_to,
              cantidad: 1,
              valor_descuento: 0,
              tipo_descuento: 'p',
              impuesto: current_producto.impuesto ?  current_producto.impuesto : this.centro.impuesto_productos,
              precio: 0,
              total: 0,
              id_pack: this.contador_pack
            }
            this.venta.lineas_venta.push(linea_venta)
          })
        }
      }

      // Esta línea es para que detecte los cambios
      this.venta = {...this.venta }
      this.$refs.scrollBottom.scrollIntoView()
    },

    get_descuento_por_periodo(servicio){
      this.descuentos_por_periodos.forEach((currentDescuento) =>{
        if(currentDescuento.servicios.includes(servicio.id)){
          if(currentDescuento.fecha_inicio <= this.venta.fecha && currentDescuento.fecha_fin >= this.venta.fecha){
            return currentDescuento.descuento
          }
        }
      });
      return 0
    },

    /**
     * Elimina una línea venta
     * @param index
     */
    async delete_linea_venta(index) {
      const linea=this.venta.lineas_venta[index]
      this.venta.lineas_venta.splice(index, 1);

      if (linea.tarjeta_regalo){
        this.set_tarjetas_regalo.delete(linea.tarjeta_regalo)
      }

      if(linea.bono){
        this.bonos_asignables[linea.bono].cantidad -= linea.cantidad

        if (this.bonos_asignables[linea.bono].modelo.total !== null) {
          this.bonos_asignables[linea.bono].disponibles.total -= this.bonos_asignables[linea.bono].modelo.total*linea.cantidad
        }

        Object.keys(this.bonos_asignables[linea.bono].disponibles.servicios).forEach((servicio)=>{
          this.bonos_asignables[linea.bono].disponibles.servicios[servicio] -= this.bonos_asignables[linea.bono].modelo.servicios[servicio]*linea.cantidad
        })
        Object.keys(this.bonos_asignables[linea.bono].disponibles.productos).forEach((producto)=>{
          this.bonos_asignables[linea.bono].disponibles.productos[producto] -= this.bonos_asignables[linea.bono].modelo.productos[producto]*linea.cantidad
        })
      }
      if(linea.bono || (linea.producto && linea.bono_vendido_id) || (linea.servicio && linea.bono_vendido_id)){
        this.desasignar_sesiones_usadas(linea)
      }
      // if (this.$store.state.centro.centro.is_ticketbai_activo && (linea.producto || linea.servicio)) {
      //   if (linea.producto && this.venta.lineas_venta.filter(current_linea => !!current_linea.producto).length === 0
      //   && this.has_added_item === 'producto') {
      //     this.has_added_item = null
      //   } else if (linea.servicio && this.venta.lineas_venta.filter(current_linea => !!current_linea.servicio).length === 0
      //       && this.has_added_item === 'servicio') {
      //     this.has_added_item = null
      //   }
      // }
    },


    /**
     * Recuperar los datos necesarios para pintar el formulario
     * @returns {Promise<void>}
     */
    async get_data_form() {
      try {
        this.data_form = await this.$store.dispatch('venta/get_form')

        //si el usuario que está creando la venta no es un empleado (por ejemplo el admin del centro) se tiene que añadir manualmente
        if(!this.user.is_employee){
          this.data_form.empleados.push({text: this.user.nombre_completo, value: this.user.id})
        }

        // si se edita una venta que realizó un usuario no empleado se tiene que añadir manualmente o no se vé el nombre
        if(this.item && this.item.id){
          const found = this.data_form.empleados.find(empleado => empleado.value === this.item.assigned_to)
          if(!found){
            try {
              let empleado = await this.$store.dispatch('user/get_empleado', this.item.assigned_to)
              this.data_form.empleados.push({text: empleado.nombre_completo, value: empleado.id})
            } catch (err) {
              let empleado = await this.$store.dispatch('user/get_empleado_empresa', this.item.assigned_to)
              this.data_form.empleados.push({text: empleado.nombre_completo, value: empleado.id, disabled: true})
            }
          }
        }

        if (this.item && (this.item.pedido || this.item.is_rectificada)) {
          this.data_form.formas_pago = this.data_form.formas_pago.filter(
              forma_pago => forma_pago.value !== CONSTANTS.FORMAS_PAGO.TARJETA_REGALO && forma_pago.value !== CONSTANTS.FORMAS_PAGO.TARJETA_FIDELIDAD
          )
        }
      } catch (err) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    /**
     * Devuelve el valor de un impuesto a partir del value del desplegable
     * @param value
     * @returns {number}
     */
    get_valor_impuesto(value){
      let valor_impuesto = 0;
      this.data_form.impuestos.forEach((current_object_impuesto) => {
        if(current_object_impuesto.value === value) {
          valor_impuesto = current_object_impuesto.text
        }
      })
      return valor_impuesto
    },

    /**
     * Calcula los totales de las lineas de venta y la base imponible y el total de la venta
     */
    set_totales_venta(){
      let sum_base_imponible = 0
      let total_venta = 0
      this.venta.lineas_venta.forEach((current_linea) => {
        // calcular total
        let total = current_linea.cantidad * current_linea.precio
        if(current_linea.valor_descuento){
          if(current_linea.tipo_descuento === 'm'){
            total -= current_linea.valor_descuento
          }else{
            total -= (total*current_linea.valor_descuento/100)
          }
        }
        current_linea.total = parseFloat(total.toFixed(2))
        total_venta += current_linea.total

        // calcular base imponible
        let iva = this.get_valor_impuesto(current_linea.impuesto)
        if(iva < 10){
          iva = "0"+iva;
          iva = iva.replace(",","");
          iva = iva.replace(".","");
        }
        iva = parseFloat("1."+iva);
        sum_base_imponible += current_linea.total / iva
      })

      let impuesto_a_aplicar = sum_base_imponible? (total_venta / sum_base_imponible): 1

      if (this.item && this.item.is_rectificada) {
        // los importes que descuental al total directamente (tarjetas, puntos, etc) tienen que tener como impuesto la
        // media de impuestos de la linea original (ej: 2 lineas mismo total, 10% y 20% impuesto, se tiene que aplicar
        // 15% impuesto al descuento de puntos para que cuadre la base imponible).
        if (this.item.rectificar_puntos) {
          total_venta += this.item.rectificar_puntos
          sum_base_imponible += parseFloat(this.item.rectificar_puntos / this.item.impuesto_total_venta_original)
        }
        if (this.item.importe_tarjeta_fidelidad_rectificar) {
          total_venta += this.item.importe_tarjeta_fidelidad_rectificar
          sum_base_imponible += parseFloat(this.item.importe_tarjeta_fidelidad_rectificar / this.item.impuesto_total_venta_original)
        }
        if (this.item.importe_tarjeta_regalo_rectificar) {
          total_venta += this.item.importe_tarjeta_regalo_rectificar
          sum_base_imponible += parseFloat(this.item.importe_tarjeta_regalo_rectificar / this.item.impuesto_total_venta_original)
        }
        // se habia añadido un concepto justo con el importe de rectificar_puntos + importe_tarjeta, da 0 siempre
        // if (impuesto_a_aplicar === 0) {
        //   impuesto_a_aplicar = sum_base_imponible? (total_venta / sum_base_imponible): 1
        // }
        total_venta = parseFloat(total_venta.toFixed(2))
      }

      // calcular el total de la venta
      if(this.venta.tipo_descuento === 'm'){
        total_venta -= this.venta.valor_descuento
      }else{
        // hacemos esto para que el descuento no afecte a los importes rectificados de tarjetas y puntos, descuadra
        // la base imponible

        if (this.item && this.item.is_rectificada) {
          if (this.item.rectificar_puntos) {
            total_venta -= this.item.rectificar_puntos
          }
          if (this.item.importe_tarjeta_regalo_rectificar) {
            total_venta -= this.item.importe_tarjeta_regalo_rectificar
          }
          if (this.item.importe_tarjeta_fidelidad_rectificar) {
            total_venta -= this.item.importe_tarjeta_fidelidad_rectificar
          }
        }

        total_venta -= (total_venta * this.venta.valor_descuento / 100)

        if (this.item && this.item.is_rectificada && this.item.impuesto_total_venta_original) {
          if (this.item.rectificar_puntos) {
            total_venta += this.item.rectificar_puntos
          }
          if (this.item.importe_tarjeta_regalo_rectificar) {
            total_venta += this.item.importe_tarjeta_regalo_rectificar
          }
          if (this.item.importe_tarjeta_fidelidad_rectificar) {
            total_venta += this.item.importe_tarjeta_fidelidad_rectificar
          }
        }
      }
      if(total_venta < 0 && (this.venta.tarjeta_fidelidad_vendida_obj || this.venta.tarjeta_fidelidad_vendida ||
          this.venta.importe_tarjeta_regalo)){
        this.desasignar_tarjeta()
        this.$snotify.error(
            this.$t("No puede canjearse tarjetas en ventas con importe negativo."),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }

      if(this.venta.tarjeta_fidelidad_vendida_obj){
        this.venta.importe_tarjeta_fidelidad = this.venta.tarjeta_fidelidad_vendida_obj.importe_restante > total_venta?
            total_venta : this.venta.tarjeta_fidelidad_vendida_obj.importe_restante
        this.venta.importe_tarjeta_fidelidad = this.venta.importe_tarjeta_fidelidad.toFixed(2)

        total_venta -= this.venta.importe_tarjeta_fidelidad

      } else if (this.venta.tarjeta_fidelidad_vendida) {
        total_venta -= this.venta.importe_tarjeta_fidelidad
      }

      if(this.venta.importe_tarjeta_regalo){
        if (this.venta.id && this.importe_tarjeta_regalo_maximo === 0) {
          this.importe_tarjeta_regalo_maximo = total_venta
        }

        this.importe_tarjeta_regalo_maximo = this.importe_tarjeta_regalo_maximo > total_venta?
            total_venta : this.importe_tarjeta_regalo_maximo

        this.venta.importe_tarjeta_regalo = this.venta.importe_tarjeta_regalo > this.importe_tarjeta_regalo_maximo?
            parseFloat(this.importe_tarjeta_regalo_maximo).toFixed(2) :
            parseFloat(this.venta.importe_tarjeta_regalo).toFixed(2)

        total_venta -= this.venta.importe_tarjeta_regalo
      }

      if(this.venta.importe_programa_puntos){
        //si no hay ventas no se usan lo puntos
        if(total_venta === 0){
          this.venta.importe_programa_puntos = 0
          this.venta.puntos_utilizados = 0
        }
        //si se modifica la venta se ajustan los puntos para no pasarse o
        // para usar mas (hasta el max de puntos del cliente)
        if (this.venta.importe_programa_puntos > total_venta){
          this.venta.puntos_utilizados = Math.ceil(total_venta/(this.venta.importe_programa_puntos/this.venta.puntos_utilizados))
          this.venta.importe_programa_puntos = (total_venta).toFixed(2)

        } else if (this.venta.importe_programa_puntos < total_venta){
          let descuentoPuntos = (this.venta.importe_programa_puntos/this.venta.puntos_utilizados)
          let puntosUsados = total_venta/descuentoPuntos
          if (this.item && this.item.importe_programa_puntos > 0){
            if (puntosUsados > this.item.puntos_utilizados) {
              this.venta.puntos_utilizados = this.item.puntos_utilizados
              this.venta.importe_programa_puntos = this.item.importe_programa_puntos
            } else {
              this.venta.puntos_utilizados=Math.ceil(puntosUsados)
              this.venta.importe_programa_puntos=(descuentoPuntos*puntosUsados).toFixed(2)
            }

          } else {
            puntosUsados = puntosUsados > this.cliente_venta.puntos ? this.cliente_venta.puntos : puntosUsados
            this.venta.puntos_utilizados=Math.ceil(puntosUsados)
            this.venta.importe_programa_puntos=(descuentoPuntos*puntosUsados).toFixed(2)
          }
        }

        total_venta -= this.venta.importe_programa_puntos
      }

      this.venta.total = parseFloat(total_venta).toFixed(2)
      let sum_importes = 0
      sum_importes += this.venta.importe_tarjeta_regalo? this.venta.importe_tarjeta_regalo : 0
      sum_importes += this.venta.importe_tarjeta_regalo? this.venta.importe_tarjeta_fidelidad : 0
      sum_importes += this.venta.importe_tarjeta_regalo? this.venta.importe_programa_puntos : 0
      if (!this.venta.total) {
        this.venta.base_imponible = 0
      } else {
        if (impuesto_a_aplicar === 0) {
          this.venta.base_imponible = sum_base_imponible.toFixed(2)
        } else {
          this.venta.base_imponible = (parseFloat(this.venta.total) / impuesto_a_aplicar).toFixed(2)
        }
        if (!this.venta.base_imponible) {
          this.venta.base_imponible = 0
        }
      }
    },

    set_entregas_en_mixto(){
      if(this.venta.forma_pago === 6){
        this.venta.entrega = parseFloat(this.venta.entrega_efectivo) + parseFloat(this.venta.entrega_tarjeta)
      }
    },

    reset_autocomplete() {
      this.cliente_autocomplete = null
      this.cliente_autocomplete_q = ''
      this.cliente_autocomplete_entries = []
    },

    /**
     * Clientes autocomplete
     */
    async get_clientes_autocomplete() {
      if (this.cliente_autocomplete_q.length < 3) return
      const resp = await this.$store.dispatch('cliente/get_clientes_autocomplete', this.cliente_autocomplete_q)
      this.cliente_autocomplete_entries = resp.results
    },

    /**
     * Carga el cliente anónimo para la venta
     */
    async get_anonymous() {
      const cliente_anonimo = await this.$store.dispatch('cliente/get_cliente_anonimo')

      this.data_form.formas_pago = this.data_form.formas_pago.filter(
          (f)=> f.value !== CONSTANTS.FORMAS_PAGO.TARJETA_FIDELIDAD
      )

      this.cliente_venta = cliente_anonimo
      this.venta.cliente = cliente_anonimo.value
      // Esta línea es para que detecte los cambios
      this.venta = {...this.venta }
    },

    desasignar_puntos(){
      if(this.venta.id) {
        this.$snotify.error(
            this.$t('No se puede desasignar los puntos de una venta ya realizada.'),
        )
        return
      }

      this.$snotify.warning(
          this.$t('Desasignados puntos utilizados.'),
      )

      this.venta.importe_programa_puntos = 0
      this.venta.puntos_utilizados = 0
    },

    desasignar_tarjeta(){
      if(this.venta.tarjeta_fidelidad_vendida || this.venta.tarjeta_regalo_usada) {
        this.$snotify.warning(
            this.$t('Desasignada tarjeta canjeada.'),
        )
      }

      if (this.venta.tarjeta_fidelidad_vendida) {
        this.$snotify.warning(
            this.$t('Anulado descuento en servicios y productos.'),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
        this.venta.lineas_venta.forEach((current_linea)=> {
          if (current_linea.servicio || current_linea.producto) {
            current_linea.valor_descuento = 0
            current_linea.tipo_descuento = 'p'
          }
        })

        this.venta.tarjeta_fidelidad_vendida = null
        this.venta.tarjeta_fidelidad_vendida_obj = null
        this.venta.importe_tarjeta_fidelidad = 0
      }

      if (this.venta.tarjeta_regalo_usada) {
        this.venta.tarjeta_regalo_usada = null
        this.importe_tarjeta_regalo_maximo = null
        this.venta.importe_tarjeta_regalo = 0
      }
    },

    async set_forma_pago(forma_pago_id){
      const form_valid = await this.$refs.validationObserver.validate()

      if (form_valid) {
        if (forma_pago_id === CONSTANTS.FORMAS_PAGO.TARJETA_FIDELIDAD && (!this.venta.tarjeta_fidelidad_vendida ||
            this.venta.total > 0)) {
          await this.desasignar_tarjeta()
          // this.$snotify.info(
          //     this.$t('Selecciona una tarjeta con saldo restante mayor o igual a {0}.', [this.venta.total]),
          //     this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          // )
          this.open_dialog_canjear_tarjeta(2)

        } else if (forma_pago_id === CONSTANTS.FORMAS_PAGO.TARJETA_REGALO && (!this.venta.tarjeta_regalo_usada ||
            this.venta.total > 0)) {
          await this.desasignar_tarjeta()
          // this.$snotify.info(
          //     this.$t('Selecciona una tarjeta con saldo restante mayor o igual a {0}.', [this.venta.total]),
          //     this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          // )
          this.open_dialog_canjear_tarjeta(1)

        } else {
          this.venta.forma_pago = forma_pago_id
          this.venta.entrega = this.venta.total
          this.is_finalizar_venta = true
        }
      }
    },

    /**
     * Comprueba si el cliente tiene un bono disponible para un línea venta
     * @param linea_venta
     */
    check_bono(linea_venta){

      if(this.cliente_venta.is_anonymous || linea_venta.bono_vendido_id) return
      if(!linea_venta.servicio && !linea_venta.producto) return

      Vue.set(linea_venta,'bono_vendido_id_previo_aux', null )
      Vue.set(linea_venta,'bono_vendido_id_aux', null )
      Vue.set(linea_venta,'limite_unidades_bono', null )

      let fecha_caducidad = null

      // Comprobamos si el servicio o producto está incluído en algún bono que ya tenga el cliente.
      // Se prioriza el que caduque antes
      Object.keys(this.bonos_previos).every((id_bono)=>{
        let bono_vendido_id_previo=this.bonos_previos[id_bono]

        if(linea_venta.servicio){
          if(linea_venta.servicio in bono_vendido_id_previo.modelo.servicios
              && bono_vendido_id_previo.modelo.servicios[linea_venta.servicio] >= linea_venta.cantidad
              && bono_vendido_id_previo.disponibles.servicios[linea_venta.servicio] -
              bono_vendido_id_previo.usados.servicios[linea_venta.servicio] >= linea_venta.cantidad
              && (bono_vendido_id_previo.disponibles.total === null ||
                  bono_vendido_id_previo.disponibles.total - bono_vendido_id_previo.usados.total >= linea_venta.cantidad)
              && (!fecha_caducidad || bono_vendido_id_previo.fecha_caducidad < fecha_caducidad)){
            Vue.set(linea_venta,'bono_vendido_id_previo_aux', id_bono )
            fecha_caducidad = bono_vendido_id_previo.fecha_caducidad

            if(bono_vendido_id_previo.modelo.total !== null) {
              Vue.set(linea_venta,'limite_unidades_bono',
                  Math.min(bono_vendido_id_previo.modelo.servicios[linea_venta.servicio], bono_vendido_id_previo.modelo.total))
            } else {
              Vue.set(linea_venta,'limite_unidades_bono', bono_vendido_id_previo.modelo.servicios[linea_venta.servicio])
            }
          }
        }

        if(linea_venta.producto){
          if(linea_venta.producto in bono_vendido_id_previo.modelo.productos
              && bono_vendido_id_previo.modelo.productos[linea_venta.producto] >= linea_venta.cantidad
              && bono_vendido_id_previo.disponibles.productos[linea_venta.producto] -
              bono_vendido_id_previo.usados.productos[linea_venta.producto] >= linea_venta.cantidad
              && (bono_vendido_id_previo.disponibles.total === null ||
                  bono_vendido_id_previo.disponibles.total - bono_vendido_id_previo.usados.total >= linea_venta.cantidad)
              && (!fecha_caducidad || bono_vendido_id_previo.fecha_caducidad < fecha_caducidad)){
            Vue.set(linea_venta,'bono_vendido_id_previo_aux', id_bono )
            fecha_caducidad = bono_vendido_id_previo.fecha_caducidad

            if(!bono_vendido_id_previo.modelo.total === null) {
              Vue.set(linea_venta,'limite_unidades_bono',
                  Math.min(bono_vendido_id_previo.modelo.productos[linea_venta.producto], bono_vendido_id_previo.modelo.total))
            } else {
              Vue.set(linea_venta,'limite_unidades_bono', bono_vendido_id_previo.modelo.productos[linea_venta.producto])
            }
          }
        }
        return true
      })

      if(linea_venta.bono_vendido_id_previo_aux !== null) return;

      // Comprobamos si está incluído en algún bono de la venta actual. En cuanto se encuentra uno para
      Object.keys(this.bonos_asignables).every((id_bono)=>{
        let bono_asignable=this.bonos_asignables[id_bono]

        if(linea_venta.servicio){
          if(linea_venta.servicio in bono_asignable.modelo.servicios
              && bono_asignable.modelo.servicios[linea_venta.servicio] >= linea_venta.cantidad
              && bono_asignable.disponibles.servicios[linea_venta.servicio] -
              bono_asignable.usados.servicios[linea_venta.servicio] >= linea_venta.cantidad
              && (bono_asignable.disponibles.total === null ||
                  bono_asignable.disponibles.total - bono_asignable.usados.total >= linea_venta.cantidad)){
            Vue.set(linea_venta,'bono_vendido_id_aux', id_bono )

            if(!bono_asignable.modelo.total === null) {
              Vue.set(linea_venta,'limite_unidades_bono',
                  Math.min(bono_asignable.modelo.servicios[linea_venta.servicio], bono_asignable.modelo.total,
                      bono_asignable.disponibles.servicios[linea_venta.servicio] - bono_asignable.usados.servicios[linea_venta.servicio],
                      bono_asignable.disponibles.total - bono_asignable.usados.total))
            } else {
              Vue.set(linea_venta,'limite_unidades_bono', Math.min(bono_asignable.modelo.servicios[linea_venta.servicio],
                  bono_asignable.disponibles.servicios[linea_venta.servicio] - bono_asignable.usados.servicios[linea_venta.servicio]))
            }
            return false
          }
        }

        if(linea_venta.producto){
          if(linea_venta.producto in bono_asignable.modelo.productos
              && bono_asignable.modelo.productos[linea_venta.producto] >= linea_venta.cantidad
              && bono_asignable.disponibles.productos[linea_venta.producto] -
              bono_asignable.usados.productos[linea_venta.producto] >= linea_venta.cantidad
              && (bono_asignable.disponibles.total === null ||
                  bono_asignable.disponibles.total - bono_asignable.usados.total >= linea_venta.cantidad)){
            Vue.set(linea_venta,'bono_vendido_id_aux', id_bono )

            if(!bono_asignable.modelo.total === null) {
              Vue.set(linea_venta,'limite_unidades_bono',
                  Math.min(bono_asignable.modelo.productos[linea_venta.producto], bono_asignable.modelo.total,
                      bono_asignable.disponibles.productos[linea_venta.producto] - bono_asignable.usados.productos[linea_venta.producto],
                      bono_asignable.disponibles.total - bono_asignable.usados.total))
            } else {
              Vue.set(linea_venta,'limite_unidades_bono', Math.min(bono_asignable.modelo.productos[linea_venta.producto],
                  bono_asignable.disponibles.productos[linea_venta.producto] - bono_asignable.usados.productos[linea_venta.producto]))
            }

            return false
          }
        }
        return true
      })
    },

    /**
     * Canjea la sesión de un bono
     * @param linea_venta
     */
    usar_sesion(linea_venta){
      let bono_id
      let bono_usado
      let bono_a_usar
      let bono_gastado

      //Si la linea está asignada a un bono que ya tenía el cliente o a un bono que vendemos en la propia venta
      if(linea_venta.bono_vendido_id_previo_aux) {
        bono_id=linea_venta.bono_vendido_id_previo_aux
        bono_a_usar = this.bonos_previos[bono_id]
        bono_gastado = this.bonos_gastados.previos

      } else if(linea_venta.bono_vendido_id_aux) {
        bono_id=linea_venta.bono_vendido_id_aux
        bono_a_usar = this.bonos_asignables[linea_venta.bono_vendido_id_aux]
        bono_gastado = this.bonos_gastados.nuevos
      }

      if (linea_venta.servicio) {
        //cantidad <= cantidad disponible y cantidad maxima asignable a cada servicio
        if (Number(linea_venta.cantidad) <= bono_a_usar.modelo.servicios[linea_venta.servicio]
            && bono_a_usar.disponibles.servicios[linea_venta.servicio] - bono_a_usar.usados.servicios[linea_venta.servicio] >= Number(linea_venta.cantidad)
            && (bono_a_usar.disponibles.total === null ||
                bono_a_usar.disponibles.total >= bono_a_usar.usados.total + Number(linea_venta.cantidad))) {
          Vue.set(bono_a_usar.usados.servicios, linea_venta.servicio, bono_a_usar.usados.servicios[linea_venta.servicio] + Number(linea_venta.cantidad))

          if (bono_a_usar.modelo.total !== null) {
            Vue.set(bono_a_usar.usados, 'total', bono_a_usar.usados.total + Number(linea_venta.cantidad))
          }

          Vue.set(linea_venta, 'bono_vendido_id', bono_id)
          bono_usado = bono_id

          //  Comprobar si se añade a bonos gastados
          if(linea_venta.bono_vendido_id_aux || linea_venta.bono_vendido_id_previo_aux) {
            if((bono_a_usar.modelo.total !== null && bono_a_usar.usados.total % bono_a_usar.modelo.total === 0) ||
                this.check_bono_consumidas_sesiones(bono_a_usar, bono_id)){
              bono_gastado[bono_usado] = bono_gastado[bono_usado]? bono_gastado[bono_usado] + 1 : 1
              bono_gastado.count +=1
            }
          }

        } else {
          this.$snotify.error(
            this.$t("No se puede superar el límite de sesiones del bono.") + '\n' + this.$t('Sesiones máximas aplicables al bono:')
                + ' ' + Math.min(bono_a_usar.modelo.servicios[linea_venta.servicio], bono_a_usar.disponibles.total - bono_a_usar.usados.total),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }

      } else if (linea_venta.producto) {
        if (Number(linea_venta.cantidad) <= bono_a_usar.modelo.productos[linea_venta.producto]
            && bono_a_usar.disponibles.productos[linea_venta.producto] - bono_a_usar.usados.productos[linea_venta.producto] >= Number(linea_venta.cantidad)
            && (bono_a_usar.disponibles.total === null ||
                bono_a_usar.disponibles.total >= bono_a_usar.usados.total + Number(linea_venta.cantidad))) {
          Vue.set(bono_a_usar.usados.productos, linea_venta.producto, bono_a_usar.usados.productos[linea_venta.producto] + Number(linea_venta.cantidad))

          if (bono_a_usar.modelo.total !== null) {
            Vue.set(bono_a_usar.usados, 'total', bono_a_usar.usados.total + Number(linea_venta.cantidad))
          }

          Vue.set(linea_venta, 'bono_vendido_id', bono_id)
          bono_usado = bono_id

          //  Comprobar si se añade a bonos gastados
          if(linea_venta.bono_vendido_id_aux || linea_venta.bono_vendido_id_previo_aux) {
            if((bono_a_usar.modelo.total !== null && bono_a_usar.usados.total % bono_a_usar.modelo.total === 0) ||
                this.check_bono_consumidas_sesiones(bono_a_usar, bono_id)){
              bono_gastado[bono_usado] = bono_gastado[bono_usado]? bono_gastado[bono_usado] + 1 : 1
              bono_gastado.count +=1
            }
          }

        } else {
          this.$snotify.error(
            this.$t("No se puede superar el límite de sesiones del bono.") + '\n' + this.$t('Sesiones máximas aplicables al bono:')
                + ' ' + Math.min(bono_a_usar.modelo.productos[linea_venta.producto], bono_a_usar.disponibles.total - bono_a_usar.usados.total),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }
      }


      if(bono_usado){
        this.venta.lineas_venta.forEach((linea_a_revisar)=>{
          //si se usa todas las unidades disponibles se desasignaran los bono_vendido_id_aux
          if((linea_a_revisar.bono_vendido_id_aux === bono_usado || linea_a_revisar.bono_vendido_id_previo_aux === bono_usado)
              && !linea_a_revisar.bono_vendido_id){
            this.check_bono(linea_a_revisar)
          }
        })
      }
      if(linea_venta.bono_vendido_id){
        //para poner a 0 el precio/recuperar el original
        if(!linea_venta.precio_aux){
          linea_venta['precio_aux'] = linea_venta.precio
        }
        linea_venta.precio = 0
      }
    },

    desasignar_sesiones_usadas(linea_venta){
      //si se desasigna un bono
      if(linea_venta.bono){
        this.venta.lineas_venta.forEach((linea_a_revisar)=> {

          //si tiene el bono desasignado se quita, si lo tiene en _aux se quita el aux
          if (linea_a_revisar.bono_vendido_id === linea_venta.bono+"") {
            this.desasignar_sesiones_usadas(linea_a_revisar)
            Vue.set(linea_a_revisar, 'bono_vendido_id', null)
            Vue.set(linea_a_revisar, 'precio', linea_a_revisar.precio_aux)
            this.check_bono(linea_a_revisar)

          } else if(linea_a_revisar.bono_vendido_id_aux === linea_venta.bono+""){
            Vue.set(linea_a_revisar, 'bono_vendido_id_aux', null)
            this.check_bono(linea_a_revisar)

          } else if(linea_a_revisar.bono_vendido_id_previo_aux === linea_venta.bono+""){
            Vue.set(linea_a_revisar, 'bono_vendido_id_previo_aux', null)
            this.check_bono(linea_a_revisar)
          }
        })
      }
      //si se desasigna un servicio
      else if(linea_venta.servicio && linea_venta.bono_vendido_id){
        //se actualizan las unidades usadas
        if(linea_venta.bono_vendido_id_aux){

          this.bonos_asignables[linea_venta.bono_vendido_id].usados.servicios[linea_venta.servicio] -= Number(linea_venta.cantidad)

          if (this.bonos_asignables[linea_venta.bono_vendido_id].modelo.total !== null) {
            this.bonos_asignables[linea_venta.bono_vendido_id].usados.total -= Number(linea_venta.cantidad)
          }

          if(this.bonos_gastados.nuevos[linea_venta.bono_vendido_id_aux] > 0 &&
              ((this.bonos_asignables[linea_venta.bono_vendido_id].modelo.total !== null &&
                      this.bonos_asignables[linea_venta.bono_vendido_id].usados.total %
                      this.bonos_asignables[linea_venta.bono_vendido_id].modelo.total === 0) ||
                  this.check_bono_consumidas_sesiones(this.bonos_asignables[linea_venta.bono_vendido_id], linea_venta.bono_vendido_id, true))){
            this.bonos_gastados.nuevos[linea_venta.bono_vendido_id_aux] -= 1
            this.bonos_gastados.nuevos.count -= 1
          }

        } else if(linea_venta.bono_vendido_id_previo_aux){

          this.bonos_previos[linea_venta.bono_vendido_id].usados.servicios[linea_venta.servicio] -= Number(linea_venta.cantidad)

          if (this.bonos_previos[linea_venta.bono_vendido_id].modelo.total !== null) {
            this.bonos_previos[linea_venta.bono_vendido_id].usados.total -= Number(linea_venta.cantidad)
          }

          if(this.bonos_gastados.previos[linea_venta.bono_vendido_id_previo_aux] > 0 &&
              ((this.bonos_previos[linea_venta.bono_vendido_id].modelo.total !== null &&
                      this.bonos_previos[linea_venta.bono_vendido_id].usados.total %
                      this.bonos_previos[linea_venta.bono_vendido_id].modelo.total === 0) ||
                  this.check_bono_consumidas_sesiones(this.bonos_previos[linea_venta.bono_vendido_id], linea_venta.bono_vendido_id, true))){
            this.bonos_gastados.previos[linea_venta.bono_vendido_id_previo_aux] -= 1
            this.bonos_gastados.previos.count -= 1
          }

        }
        this.venta.lineas_venta.forEach((current_linea)=>{
          if(current_linea.servicio && current_linea.servicio === linea_venta.servicio && !current_linea.bono_vendido_id){
            this.check_bono(current_linea)
          }
        })
      }
      //si se desasigna un producto
      else if(linea_venta.producto && linea_venta.bono_vendido_id){
        //se actualizan las unidades usadas
        if(linea_venta.bono_vendido_id_aux){

          this.bonos_asignables[linea_venta.bono_vendido_id].usados.productos[linea_venta.producto] -= Number(linea_venta.cantidad)

          if (this.bonos_asignables[linea_venta.bono_vendido_id].modelo.total !== null) {
            this.bonos_asignables[linea_venta.bono_vendido_id].usados.total -= Number(linea_venta.cantidad)
          }

          if(this.bonos_gastados.nuevos[linea_venta.bono_vendido_id_aux] > 0 &&
              ((this.bonos_asignables[linea_venta.bono_vendido_id].modelo.total !== null &&
                      this.bonos_asignables[linea_venta.bono_vendido_id].usados.total %
                      this.bonos_asignables[linea_venta.bono_vendido_id].modelo.total === 0) ||
                  this.check_bono_consumidas_sesiones(this.bonos_asignables[linea_venta.bono_vendido_id], linea_venta.bono_vendido_id, true))){
            this.bonos_gastados.nuevos[linea_venta.bono_vendido_id_aux] -= 1
            this.bonos_gastados.nuevos.count -= 1
          }

        } else if(linea_venta.bono_vendido_id_previo_aux){

          this.bonos_previos[linea_venta.bono_vendido_id].usados.productos[linea_venta.producto] -= Number(linea_venta.cantidad)

          if (this.bonos_previos[linea_venta.bono_vendido_id].modelo.total !== null) {
            this.bonos_previos[linea_venta.bono_vendido_id].usados.total -= Number(linea_venta.cantidad)
          }

          if(this.bonos_gastados.previos[linea_venta.bono_vendido_id_previo_aux] > 0 &&
              ((this.bonos_previos[linea_venta.bono_vendido_id].modelo.total !== null &&
                      this.bonos_previos[linea_venta.bono_vendido_id].usados.total %
                      this.bonos_previos[linea_venta.bono_vendido_id].modelo.total === 0) ||
                  this.check_bono_consumidas_sesiones(this.bonos_previos[linea_venta.bono_vendido_id], linea_venta.bono_vendido_id, true))){
            this.bonos_gastados.previos[linea_venta.bono_vendido_id_previo_aux] -= 1
            this.bonos_gastados.previos.count -= 1
          }
        }
        this.venta.lineas_venta.forEach((current_linea)=>{
          if(current_linea.producto && current_linea.producto === linea_venta.producto){
            this.check_bono(current_linea)
          }
        })
      }
    },

    modificar_uds_bono(linea_venta){
      let cantidad = 0
      this.venta.lineas_venta.forEach((current_linea)=>{
        if(current_linea.bono === linea_venta.bono){
          cantidad+=parseInt(current_linea.cantidad)
        }
      })
      this.bonos_asignables[linea_venta.bono].cantidad=cantidad
      if (this.bonos_asignables[linea_venta.bono].modelo.total !== null) {
        this.bonos_asignables[linea_venta.bono].disponibles.total = this.bonos_asignables[linea_venta.bono].modelo.total * cantidad
      }

      //recalculamos las unidades disponibles de cada servicio/producto
      Object.keys(this.bonos_asignables[linea_venta.bono].disponibles.servicios).forEach((servicio)=>{
        Vue.set(this.bonos_asignables[linea_venta.bono].disponibles.servicios, servicio,
            this.bonos_asignables[linea_venta.bono].modelo.servicios[servicio]*cantidad)
      })
      Object.keys(this.bonos_asignables[linea_venta.bono].disponibles.productos).forEach((producto)=>{
        Vue.set(this.bonos_asignables[linea_venta.bono].disponibles.productos, producto,
            this.bonos_asignables[linea_venta.bono].modelo.productos[producto]*cantidad)
      })

      //Reasignamos las lineas
      this.desasignar_sesiones_usadas(linea_venta)
      this.venta.lineas_venta.forEach((current_linea) => {
        if((current_linea.servicio || current_linea.producto) && !(
            current_linea.bono_vendido_id_aux || current_linea.bono_vendido_id_previo_aux)){
          this.check_bono(current_linea)
        }
      })
    },

    modificar_uds_pack(linea_modificada){
      this.venta.lineas_venta.forEach((current_linea)=>{
        if(current_linea.id_pack && current_linea.id_pack === linea_modificada.id_pack){
          current_linea.cantidad = parseInt(linea_modificada.cantidad)
        }
      })
    },

    usar_puntos(puntos){
      if (this.venta.is_rectificada) {
        return this.$snotify.warning(
            this.$t('No se puede usar puntos en una venta rectificada')
        )
      }
      this.venta.puntos_utilizados = puntos.puntos_utilizados
      this.venta.importe_programa_puntos = puntos.importe_programa_puntos
      this.dialog_usar_puntos = false
      // Esta línea es para que detecte los cambios
      this.venta = {...this.venta }
    },

    toggle_collapse(linea_venta){
      if(!linea_venta) return

      Vue.set(linea_venta, 'collapsed', !linea_venta.collapsed)
      // linea_venta.collapsed = !linea_venta.collapsed
      // Esta línea es para que detecte los cambios
      this.venta.lineas_venta = [...this.venta.lineas_venta]
    },

    open_dialog_deudas_cliente(){
      this.dialog_deudas_cliente = true
    },

    open_dialog_usar_puntos(){
      this.dialog_usar_puntos = true
    },

    open_dialog_canjear_tarjeta(show_specific_tab){
      this.show_specific_tab = show_specific_tab
      this.dialog_canjear_tarjeta = true
    },

    set_tarjeta_regalo(data){
      this.venta.tarjeta_regalo_usada = data['tarjeta_regalo'].id
      this.venta.importe_tarjeta_regalo = data['importe_tarjeta_regalo']
      this.importe_tarjeta_regalo_maximo = parseFloat(this.venta.importe_tarjeta_regalo)
      this.dialog_canjear_tarjeta = false

      // Esta línea es para que detecte los cambios
      this.venta = {...this.venta }
    },

    set_tarjeta_fidelidad(tarjeta){
      if (this.cliente_venta.is_anonymous) {
        return this.$snotify.error(
            this.$t('Un cliente anónimo no puede usar tarjetas de fidelidad'),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
      this.venta.tarjeta_fidelidad_vendida = tarjeta.id
      this.venta.tarjeta_fidelidad_vendida_obj = tarjeta
      this.dialog_canjear_tarjeta = false

      this.venta.lineas_venta.forEach((current_linea)=> {
        if (current_linea.servicio || current_linea.producto) {
          current_linea.valor_descuento = current_linea.servicio?
              this.venta.tarjeta_fidelidad_vendida_obj.descuento_servicios : this.venta.tarjeta_fidelidad_vendida_obj.descuento_productos
          current_linea.tipo_descuento = 'p'
        }
      })

      // Esta línea es para que detecte los cambios
      this.venta = {...this.venta }
    },

    open_dialog_cliente() {
      // Hemos hecho clic en el botón nuevo cliente
      this.current_cliente = {}
      this.dialog_cliente = true
    },

    click_nuevo_servicio(){
      this.dialog_servicio = true
    },

    click_nuevo_producto(){
      this.dialog_producto = true
    },

    click_nuevo_bono(){
      this.dialog_bono = true
    },

    click_nuevo_pack(){
      this.dialog_pack = true
    },

    click_nueva_tarjeta_regalo(){
      this.dialog_tarjeta_regalo = true
    },

    click_nueva_tarjeta_fidelidad(){
      this.dialog_tarjeta_fidelidad = true
    },

    click_nueva_suscripcion(){
      this.dialog_suscripcion = true
    },

    on_save_servicio(data){
      this.dialog_servicio = false
      this.$refs.tabla_items.$refs.tab_servicio[0].get_servicios()
      let servicio = data.servicio
      this.add_linea_venta(servicio, 'tab-servicio')
    },

    on_save_producto(data){
      this.dialog_producto = false
      this.$refs.tabla_items.$refs.tab_producto[0].get_productos()
      let producto = data.producto
      this.add_linea_venta(producto, 'tab-producto')
    },

    on_save_bono(data){
      this.dialog_bono = false
      this.$refs.tabla_items.$refs.tab_bono[0].get_bonos()
      let bono = data.bono
      this.add_linea_venta(bono, 'tab-bono')
    },

    on_save_pack(data){
      this.dialog_pack = false
      this.$refs.tabla_items.$refs.tab_pack[0].get_packs()
      let pack = data.pack
      this.add_linea_venta(pack, 'tab-pack')
    },

    on_save_tarjeta_regalo(data){
      this.dialog_tarjeta_regalo = false
      this.$refs.tabla_items.$refs.tab_tarjeta_regalo[0].get_tarjetas_regalo()
      let tarjeta_regalo = data.tarjeta_regalo
      this.add_linea_venta(tarjeta_regalo, 'tab-tarjeta_regalo')
    },

    on_save_tarjeta_fidelidad(data){
      this.dialog_tarjeta_fidelidad = false
      this.$refs.tabla_items.$refs.tab_tarjeta_fidelidad[0].get_tarjetas_fidelidad()
      let tarjeta_fidelidad = data.tarjeta_fidelidad
      this.add_linea_venta(tarjeta_fidelidad, 'tab-tarjeta_fidelidad')
    },

    on_save_suscripcion(data){
      this.dialog_suscripcion = false
      this.$refs.tabla_items.$refs.tab_suscripcion[0].get_suscripciones()
      let suscripcion = data.suscripcion
      this.add_linea_venta(suscripcion, 'tab-suscripcion')
    },

    check_bono_consumidas_sesiones(bono, bono_id, is_desasignar=false){
      let offset = 1
      if (this.bonos_gastados.nuevos[bono_id]) {
        if (is_desasignar){
          offset = this.bonos_gastados.nuevos[bono_id]
        } else {
          offset = this.bonos_gastados.nuevos[bono_id] + 1
        }
      }

      if (is_desasignar) {
        let cons_servicio = false
        let cons_producto = false

        Object.keys(bono.modelo.servicios).forEach((key_servicio)=>{
          if (bono.usados.servicios[key_servicio] < bono.modelo.servicios[key_servicio] * offset) {
            cons_servicio = true
          }
        })

        Object.keys(bono.modelo.productos).forEach((key_producto)=>{
          if (bono.usados.productos[key_producto] < bono.modelo.productos[key_producto] * offset) {
            cons_producto = true
          }
        })

        return cons_servicio || cons_producto

      } else {
        let consumido = true
        Object.keys(bono.modelo.servicios).forEach((key_servicio)=>{
          if (bono.usados.servicios[key_servicio] < bono.modelo.servicios[key_servicio] * offset) {
            consumido = false
          }
        })

        if (consumido){
          Object.keys(bono.modelo.productos).forEach((key_producto)=>{
            if (bono.usados.productos[key_producto] < bono.modelo.productos[key_producto] * offset) {
              consumido = false
            }
          })
        }
        return consumido
      }
    },

    async get_descuentos_por_periodos(){
      try{
        let response = await this.$store.dispatch('descuento_periodo/get_descuentos', {params: {
          is_active: 1, fecha_fin: this.$moment().format('YYYY-MM-DD')}})
        this.descuentos_por_periodos = response['results']
      }catch (e) {
        console.log(e)
      }

    },

    set_cliente(cliente){
      this.cliente_venta=cliente;
      this.venta.cliente=cliente.id;
      this.dialog_cliente=false;
    },

    async set_user_venta(){
      if(!this.venta.id || !this.venta.assigned_to ||
          (!!this.venta.centro && this.venta.centro !== this.$store.state.centro.centro.id)){ return }
      try {
        await this.$store.dispatch("venta/update_user_venta", {
          venta_id: this.venta.id, user_id: this.venta.assigned_to,
        })
        this.$snotify.success(
            this.$t("Acción realizada con éxito"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      } catch (err) {
      }
    }
  },


  async mounted() {
    await this.get_data_form()

    switch(this.$moment().weekday()) {
      case 0:
        this.tarifa = this.$store.state.centro.centro.tarifas['monday']
        break;
      case 1:
        this.tarifa = this.$store.state.centro.centro.tarifas['tuesday']
        break;
      case 2:
        this.tarifa = this.$store.state.centro.centro.tarifas['wednesday']
        break;
      case 3:
        this.tarifa = this.$store.state.centro.centro.tarifas['thursday']
        break;
      case 4:
        this.tarifa = this.$store.state.centro.centro.tarifas['friday']
        break;
      case 5:
        this.tarifa = this.$store.state.centro.centro.tarifas['saturday']
        break;
      case 6:
        this.tarifa = this.$store.state.centro.centro.tarifas['sunday']
        break;
    }

    await this.initialize_venta()
    this.venta = { ...this.venta, ...this.item }

    if(!this.venta.id){
      await this.get_descuentos_por_periodos()

    } else if (this.venta.tarjeta_fidelidad_vendida || this.venta.tarjeta_regalo_usada) {
      this.data_form.formas_pago = this.data_form.formas_pago.filter(
          (f)=> f.value !== CONSTANTS.FORMAS_PAGO.TARJETA_REGALO && f.value !== CONSTANTS.FORMAS_PAGO.TARJETA_FIDELIDAD
      )
    }


    if(this.venta.citas === null){
      this.venta.citas = []
    }

    if(this.item && this.item.cliente_venta){
      this.cliente_venta = this.item.cliente_venta
    } else if(this.cliente) {
      const cliente = await this.$store.dispatch('cliente/get_cliente', this.cliente.id)
      if (!cliente.is_agree_rgpd) {
        this.$snotify.warning(
            this.$t("El cliente no ha firmado la Política de Privacidad"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
      this.cliente_venta = cliente
      this.venta.cliente = cliente.id
      if (!this.venta.id && !(this.item && this.item.pedido)) {
        this.venta.valor_descuento = this.cliente_venta.descuento_ventas
      }
    }

    if(this.venta.cliente_venta || this.cliente_venta){

      this.cliente_venta = this.cliente_venta? this.cliente_venta : { ...this.venta.cliente_venta }

      if (this.cliente_venta.is_anonymous) {
        this.data_form.formas_pago = this.data_form.formas_pago.filter(
            (f)=> f.value !== CONSTANTS.FORMAS_PAGO.TARJETA_FIDELIDAD
        )
      }

      this.cliente_venta.bonos.forEach((current_bono)=>{
        if (current_bono.is_consumido) {
          return
        }

        this.bonos_previos[current_bono.id] = {
          'disponibles': {
            'servicios': {},
            'productos': {},
            'total': current_bono.limite_sesiones
          },
          'usados':{
            'servicios': {},
            'productos': {},
            'total': 0
          },
          'modelo':{
            'servicios': {},
            'productos': {},
            'total': current_bono.limite_sesiones
          },
          'nombre': current_bono.nombre,
          'fecha': current_bono.fecha,
          'fecha_caducidad': current_bono.fecha_caducidad
        }

        current_bono.servicios.forEach((current_servicio)=>{
          this.bonos_previos[current_bono.id].modelo.servicios[current_servicio.servicio] = current_servicio.sesiones_restantes
          this.bonos_previos[current_bono.id].disponibles.servicios[current_servicio.servicio] = current_servicio.sesiones_restantes
          this.bonos_previos[current_bono.id].usados.servicios[current_servicio.servicio] = 0
          this.bonos_previos[current_bono.id].usados.total += current_servicio.consumidos

        })
        current_bono.productos.forEach((current_producto)=>{
          this.bonos_previos[current_bono.id].modelo.productos[current_producto.producto] = current_producto.sesiones_restantes
          this.bonos_previos[current_bono.id].disponibles.productos[current_producto.producto] = current_producto.sesiones_restantes
          this.bonos_previos[current_bono.id].usados.productos[current_producto.producto] = 0
          this.bonos_previos[current_bono.id].usados.total += current_producto.consumidos
        })
      })

      this.venta.lineas_venta.forEach((current_linea) => {
        if(current_linea.servicio || current_linea.producto){
          this.check_bono(current_linea)
          if(current_linea.bono_vendido){
            current_linea.bono_vendido_id=current_linea.bono_vendido
          }
        }
      })
    }

    if(this.item && this.item.lineas_venta){
      //hacer así para solucionar problemas en el update y en el collapsible
      this.venta.lineas_venta=[]
      for (let index = 0; index < this.item.lineas_venta.length; index++) {
        let nueva_linea={...this.item.lineas_venta[index]}
        nueva_linea.collapsed = true
        delete nueva_linea.sesion
        delete nueva_linea.created
        delete nueva_linea.updated

        // Al generar la venta desde presupuesto no se añaden correctamente los bonos_asignables, se hace así
        if(this.venta.presupuesto && nueva_linea.bono){

          if(!(nueva_linea.bono in this.bonos_asignables)){
            this.bonos_asignables[nueva_linea.bono] = {
              'cantidad':1,
              'disponibles': {
                'servicios': {},
                'productos': {},
                'total': 0
              },
              'usados':{
                'servicios': {},
                'productos': {},
                'total': 0
              },
              'modelo':{
                'servicios': {},
                'productos': {},
                'total': 0
              },
            }
            const data = await this.$store.dispatch('bono/get_bonos', {
              params: {
                id: nueva_linea.bono
              }
            })
            const bono = data['results'][0]

            this.bonos_asignables[bono.id].modelo.total = bono.limite_sesiones
            this.bonos_asignables[bono.id].disponibles.total = bono.limite_sesiones

            bono.servicios.forEach((current_servicio)=>{
              this.bonos_asignables[bono.id].modelo.servicios[current_servicio.servicio] = current_servicio.cantidad
              this.bonos_asignables[bono.id].disponibles.servicios[current_servicio.servicio] = current_servicio.cantidad
              this.bonos_asignables[bono.id].usados.servicios[current_servicio.servicio] = 0
              this.bonos_asignables[bono.id].usados.total += current_servicio.consumidos
            })
            bono.productos.forEach((current_producto)=>{
              this.bonos_asignables[bono.id].modelo.productos[current_producto.producto] = current_producto.cantidad
              this.bonos_asignables[bono.id].disponibles.productos[current_producto.producto] = current_producto.cantidad
              this.bonos_asignables[bono.id].usados.productos[current_producto.producto] = 0
              this.bonos_asignables[bono.id].usados.total += current_producto.consumidos
            })

          } else {
            this.bonos_asignables[nueva_linea.bono].cantidad+=1

            Object.keys(this.bonos_asignables[nueva_linea.bono].modelo.servicios).forEach((key)=>{
              this.bonos_asignables[nueva_linea.bono].disponibles.servicios[key]+=this.bonos_asignables[nueva_linea.bono].modelo.servicios[key]
            })
            Object.keys(this.bonos_asignables[nueva_linea.bono].modelo.productos).forEach((key)=>{
              this.bonos_asignables[nueva_linea.bono].disponibles.productos[key]+=this.bonos_asignables[nueva_linea.bono].modelo.productos[key]
            })

            if (this.bonos_asignables[nueva_linea.bono].modelo.total !== null) {
              this.bonos_asignables[nueva_linea.bono].disponibles.total += this.bonos_asignables[nueva_linea.bono].modelo.total
            }
          }
      }

      this.venta.lineas_venta.push(nueva_linea)
      }

      // al generar la venta desde presupuesto, para asignar los bonos y el responsable
      if(this.venta.presupuesto){
        this.venta.lineas_venta.forEach((current_linea)=>{
          current_linea.assigned_to = this.venta.assigned_to
          if(current_linea.servicio || current_linea.producto){
            this.check_bono(current_linea)
          }
        })
      }

      if(this.item.is_rectificada) {
        if (this.item.tarjeta_regalo_rectificada){
          this.venta.lineas_venta_rectificativas.push(
              {'tipo': 1, 'descripcion': this.$t('Tarjeta regalo'), 'importe': this.item.importe_tarjeta_regalo_rectificar}
          )
        }
        if (this.item.tarjeta_fidelidad_rectificada){
          this.venta.lineas_venta_rectificativas.push(
              {'tipo': 2, 'descripcion': this.$t('Tarjeta fidelidad'), 'importe': this.item.importe_tarjeta_fidelidad_rectificar}
          )
        }
        if (this.item.rectificar_puntos){
          this.venta.lineas_venta_rectificativas.push(
              {'tipo': 3, 'descripcion': this.$t('Puntos'), 'importe': this.item.rectificar_puntos}
          )
        }

        if (this.item.lista_lineas_extra && this.item.lista_lineas_extra.length > 0) {
          this.item.lista_lineas_extra.forEach((current_linea_extra)=>{
            this.venta.lineas_venta_rectificativas.push(
                {'tipo': 4, 'descripcion': current_linea_extra.descripcion, 'importe': current_linea_extra.total}
            )
          })
        }
      }
    }

    this.lista_dict = [
      {
        componente: 'TablaServicios',
        value: 'tab-servicio',
        titulo: this.$t('Servicios'),
        boton: this.$t('Nuevo servicio'),
        event: 'click_nuevo_servicio',
        on_anonymous_show: true,
      },
      {
        componente: 'TablaProductos',
        value: 'tab-producto',
        titulo: this.$t('Productos'),
        boton: this.$t('Nuevo producto'),
        event: 'click_nuevo_producto',
        on_anonymous_show: true,
      },
      {
        componente: 'TablaBonos',
        value: 'tab-bono',
        titulo: this.$t('Bonos'),
        boton: this.$t('Nuevo bono'),
        event: 'click_nuevo_bono',
      },
      {
        componente: 'TablaPacks',
        value: 'tab-pack',
        titulo: this.$t('Packs'),
        boton: this.$t('Nuevo pack'),
        event: 'click_nuevo_pack',
        on_anonymous_show: true,
      },
      {
        componente: 'TablaTarjetasRegalo',
        value: 'tab-tarjeta_regalo',
        titulo: this.$t('Tarjetas Regalo'),
        boton: this.$t('Nueva tarjeta regalo'),
        event: 'click_nueva_tarjeta_regalo',
        on_anonymous_show: true,
      },
      {
        componente: 'TablaTarjetasFidelidad',
        value: 'tab-tarjeta_fidelidad',
        titulo: this.$t('Tarjetas Fidelidad'),
        boton: this.$t('Nueva tarjeta fidelidad'),
        event: 'click_nueva_tarjeta_fidelidad',
      },
      {
        componente: 'TablaSuscripciones',
        value: 'tab-suscripcion',
        titulo: this.$t('Suscripciones'),
        boton: this.$t('Nueva suscripción'),
        event: 'click_nueva_suscripcion',
      }]
    this.venta = {...this.venta}

    // if (this.disable_cobrar_tbai) {
    //   this.has_added_item = 'servicio'
    //   this.$snotify.error(
    //       this.$t("No puedes añadir productos y servicios simultáneamente en ventas con Ticketbai activado."),
    //       this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
    //   )
    // }

    // Debouncer autocomplete cliente
    // Al dejar de escribir, inicializamos el contador
    // Buscamos el input en el DOM
    const input = document.getElementById('formventa_autocomplete_cliente')

    if(input){
      input.addEventListener('keyup', () => {
      clearTimeout(this.autocomplete_cliente_contador);
      this.autocomplete_cliente_contador = setTimeout(() => {
        this.get_clientes_autocomplete();
        }, this.autocomplete_cliente_timeout);
      });
      input.addEventListener('keydown', () => {
        clearTimeout(this.autocomplete_cliente_contador);
      });

    }
  },

  watch: {
    'venta': {
      deep: true,
      handler() {
        // nota: se llama a si mismo, coste temportal 0(3X), lo dejamos así
        this.set_totales_venta()
      }
    },

    'venta.this.venta.forma_pago': {
      handler() {
        this.set_entregas_en_mixto()
      }
    },

    /**
     * Si hay cliente seleccionado, dejamos el autocomplete de solo lectura
     */

    'cliente_autocomplete': {
      async handler(new_value){
        if (!new_value) return;
        const id_cliente = new_value

        const clientes = this.cliente_autocomplete_entries.filter((cl) => cl.value === id_cliente)
        const cliente = await this.$store.dispatch('cliente/get_cliente', clientes[0].value)
        this.cliente_venta = cliente
        this.venta.cliente = cliente.id
        if (!(this.item && this.item.pedido)) {
          this.venta.valor_descuento = this.cliente_venta.descuento_ventas
        }
        this.venta = {...this.venta}

        if(!cliente.is_agree_rgpd){
          this.$snotify.warning(
              this.$t("El cliente no ha firmado la Política de Privacidad"),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }

        if(cliente.importe_deudas){
          this.$snotify.info(
            this.$t("Cliente con deuda de {importe}", {"importe": `${cliente.importe_deudas.toFixed(2)}${this.centro.divisa_obj.simbolo}`}),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }

        if (!(this.item && this.item.pedido)) {
          this.cliente_venta.bonos.forEach((current_bono)=>{
            this.bonos_previos[current_bono.id] = {
              'disponibles': {
                'servicios': {},
                'productos': {},
                'total': current_bono.limite_sesiones
              },
              'usados':{
                'servicios': {},
                'productos': {},
                'total': 0
              },
              'modelo':{
                'servicios': {},
                'productos': {},
                'total': current_bono.limite_sesiones
              },
              'nombre': current_bono.nombre,
              'fecha': current_bono.fecha,
              'fecha_caducidad': current_bono.fecha_caducidad
            }

            current_bono.servicios.forEach((current_servicio)=>{
              this.bonos_previos[current_bono.id].modelo.servicios[current_servicio.servicio] = current_servicio.sesiones_restantes
              this.bonos_previos[current_bono.id].disponibles.servicios[current_servicio.servicio] = current_servicio.sesiones_restantes
              this.bonos_previos[current_bono.id].usados.servicios[current_servicio.servicio] = 0
              this.bonos_previos[current_bono.id].usados.total += current_servicio.consumidos

            })
            current_bono.productos.forEach((current_producto)=>{
              this.bonos_previos[current_bono.id].modelo.productos[current_producto.producto] = current_producto.sesiones_restantes
              this.bonos_previos[current_bono.id].disponibles.productos[current_producto.producto] = current_producto.sesiones_restantes
              this.bonos_previos[current_bono.id].usados.productos[current_producto.producto] = 0
              this.bonos_previos[current_bono.id].usados.total += current_producto.consumidos
            })
          })
        }
      }
    }
  },

  components: {
    ValidationProvider,
    ValidationObserver,
    MiniCliente: () => import('@/views/Clientes/Components/MiniCliente'),
    DialogDeudasCliente: () => import('@/views/Clientes/Components/DialogDeudasCliente'),
    DialogUsarPuntos: () => import('@/views/Ventas/components/DialogUsarPuntos'),
    DialogCanjearTarjeta: () => import('@/views/Ventas/components/DialogCanjearTarjeta'),
    DialogBonosGastados: () => import('@/views/Ventas/components/DialogBonosGastados'),
    DialogDescuentosPeriodo: () => import('@/views/Ventas/components/DialogDescuentosPeriodo'),
    DialogHistorial: () => import('@/views/Ventas/components/DialogHistorial'),
    FormServicio: () => import('@/views/Configuracion/Servicios/Servicios/components/FormServicio'),
    FormProducto: () => import('@/views/Configuracion/Productos/Productos/components/FormProducto'),
    FormBono: () => import('@/views/Configuracion/Bonos/components/FormBono'),
    FormPack: () => import('@/views/Configuracion/Packs/components/FormPack'),
    FormTarjetaRegalo: () => import('@/views/Marketing/TarjetasRegalo/components/FormTarjetaRegalo'),
    FormTarjetaFidelidad: () => import('@/views/Marketing/TarjetasFidelidad/components/FormTarjetaFidelidad'),
    FormSuscripcion: () => import('@/views/Configuracion/Suscripciones/components/FormSuscripcion'),
    FormCliente: () => import('@/views/Clientes/Components/FormCliente'),
    LineaFormVenta: () => import('@/views/Ventas/components/LineaFormVenta'),
    LineaRectificativaFormVenta: () => import('@/views/Ventas/components/LineaRectificativaFormVenta'),
    TabItemFormVenta: () => import('@/views/Ventas/components/TabItemFormVenta'),
    FinalizarVenta: () => import('@/views/Ventas/components/FinalizarVenta'),
  }
}
</script>

<style lang="scss" scoped>
header{
  border-radius: 0 !important;
}

.contLineasVenta {
  max-height: calc(70vh - 165px);
  overflow-y: auto;
}

.footerVenta {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 49vw;
  height: 165px;
}
@media screen and (max-width: 1263px) {
  .footerVenta{
    width: 98vw;
  }
}

.big {
  font-size: 2em
}

.v-card__text, .v-card__actions {
  padding: 0 8px;
}
.labelFooterVenta{
  background-color: white;
  color: black;
  border-radius: 4px;
  padding-left: 6px;
  padding-right: 6px
}

.bg_gradient {
  background: linear-gradient(to right, #F44336, #2196F3);
  //background-color: black;
}
</style>
